export class FirmTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      thirdPartyId: obj.attributes.third_party_id,
      data: obj.attributes.data,
      createdAt: obj.attributes.created_at,
      updatedAt: obj.attributes.updated_at,
    };
  }
}
